<template>
    <div>
        <div class="simplebar-wrapper" style="margin: 0px">
            <div class="simplebar-height-auto-observer-wrapper">
                <div class="simplebar-height-auto-observer"></div>
            </div>
            <div class="simplebar-mask">
                <div class="simplebar-offset" style="right: 0px; bottom: 0px">
                    <div
                        class="simplebar-content-wrapper"
                        tabindex="0"
                        role="region"
                        aria-label="scrollable content"
                        style="height: 100%; overflow: hidden scroll"
                    >
                        <div class="simplebar-content" style="padding: 0px">
                            <!-- Header-->
                            <slot name="overlay-header"></slot>
                            <!-- Fin Header -->
                            <div class="content-side">
                                <div class="block block-transparent pull-x pull-t row">

                                    <div class="col-12 col-md-8">
                                        <ul class="nav nav-tabs nav-justified" role="tablist">
                                            <li class="nav-item">
                                                <button
                                                    type="button"
                                                    class="nav-link active"
                                                    id="current-sale-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#current-sale"
                                                    role="tab"
                                                    aria-controls="current-sale"
                                                    aria-selected="true"
                                                >
                                                    Vente en cours
                                                </button>
                                            </li>
                                            <li class="nav-item">
                                                <button
                                                    type="button"
                                                    class="nav-link"
                                                    id="voucher-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#voucher"
                                                    role="tab"
                                                    aria-controls="voucher"
                                                    aria-selected="false"
                                                >
                                                    Bons cadeau
                                                </button>
                                            </li>
                                            <li class="nav-item">
                                                <button
                                                    type="button"
                                                    class="nav-link"
                                                    id="avoir-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#avoir"
                                                    role="tab"
                                                    aria-controls="avoir"
                                                    aria-selected="false"
                                                >
                                                    Avoirs
                                                </button>
                                            </li>
                                            <li class="nav-item">
                                                <button
                                                    type="button"
                                                    class="nav-link"
                                                    id="serie-treatment-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#serie-treatment"
                                                    role="tab"
                                                    aria-controls="serie-treatment"
                                                    aria-selected="false"
                                                >
                                                    Abonnements et cures
                                                </button>
                                            </li>
                                            <!-- <li class="nav-item">
                                                <button
                                                    type="button"
                                                    class="nav-link"
                                                    id="waiting-sales-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#waiting-sales"
                                                    role="tab"
                                                    aria-controls="waiting-sales"
                                                    aria-selected="false"
                                                >
                                                    Commandes en cours
                                                </button>
                                            </li> -->
                                        </ul>
                                        <div class="block-content tab-content overflow-hidden">
                                            <div
                                                class="tab-pane pull-x fade fade-left show active"
                                                id="current-sale"
                                                role="tabpanel"
                                                aria-labelledby="current-sale-tab"
                                            >
                                                <div class="block block-transparent">
                                                    <div class="block-content">
                                                        <!-- Payment-->
                                                        <slot name="payment-component"></slot>
                                                        <!-- Fin Payment -->
                                                    </div>
                                                </div>
                                            </div>
                                             <div
                                                class="tab-pane pull-x fade fade-right"
                                                id="voucher"
                                                role="tabpanel"
                                                aria-labelledby="voucher-tab"
                                            >
                                                <div class="block block-transparent mb-0">
                                                    <div class="block-content">
                                                        <!-- Voucher tab -->
                                                        <slot name="voucher-tab"></slot>
                                                        <!-- Fin Voucher tab -->
                                                    </div>
                                                </div>
                                            </div>
                                             <div
                                                class="tab-pane pull-x fade fade-right"
                                                id="avoir"
                                                role="tabpanel"
                                                aria-labelledby="avoir-tab"
                                            >
                                                <div class="block block-transparent mb-0">
                                                    <div class="block-content">
                                                        <!-- Avoir tab -->
                                                        <slot name="avoir-tab"></slot>
                                                        <!-- Fin Avoir tab -->
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="tab-pane pull-x fade fade-right"
                                                id="serie-treatment"
                                                role="tabpanel"
                                                aria-labelledby="serie-treatment-tab"
                                            >
                                                <div class="block block-transparent mb-0">
                                                    <div class="block-content">
                                                        <slot name="serie-treatment-tab"></slot>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="tab-pane pull-x fade fade-right"
                                                id="waiting-sales"
                                                role="tabpanel"
                                                aria-labelledby="waiting-sales-tab"
                                            >
                                                <div class="block block-transparent mb-0">
                                                    <div class="block-content">
                                                        <!-- waiting-sales-tab -->
                                                        <slot name="waiting-sales-tab"></slot>
                                                        <!-- fin waiting-sales-tab -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <!-- Card-->
                                        <slot name="card-component"></slot>
                                        <!-- Fin Card -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="simplebar-placeholder" style="width: auto"></div>
        </div>
        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden">
            <div class="simplebar-scrollbar" style="width: 0px; display: none"></div>
        </div>
        <div class="simplebar-track simplebar-vertical" style="visibility: visible">
            <div class="simplebar-scrollbar" style="height: 402px; transform: translate3d(0px, 0px, 0px); display: block"></div>
        </div>
    </div>
</template>

<script>
export default {}
</script>
